module.exports = __webpack_public_path__ + "img/inboxes.d60b8e19.svg";